import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function CommisChefLevel2() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    Commis Chef Level 2 Apprenticeship
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    ST0228 - Start Your Culinary Journey
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content Section */}
        <section id="commis-chef-level-2" className="commis-chef section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  
                  {/* Title */}
                  <div className="text-center mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '2rem', fontWeight: '700', marginBottom: '10px' }}>
                      COMMIS CHEF Level 2 APPRENTICESHIP ST0228
                    </h3>
                  </div>

                  {/* Occupation Summary */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Occupation summary
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      This occupation is found in the Hospitality industry across a range of sectors including hospitality, aviation and care. Commis chefs may work in different types of organisations and employers such as restaurants, hotels, care homes/hospitals, military establishments and cruise ships.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The broad purpose of the occupation is to support the kitchen in providing the culinary offer, by preparing, cooking and finishing a range of food items whilst rotating around each section of the kitchen.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      Commis chefs will work as part of a kitchen brigade to ensure the quality of the food items produced meet brand, organisational and legislative requirements including the completion of food safety management documentation. They receive, check and correctly store deliveries as well as checking and reporting food items and stock levels.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      Commis chefs contribute to improving the culinary offer of their organisation. In their daily work, an employee in this occupation interacts with a team (brigade) of chefs, the wider team including front of house staff, suppliers and customers.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      Commis chefs may work unsociable hours, including early mornings, late evenings, weekends and holidays. An employee in this occupation will be responsible for maintaining high standards of personal, food and kitchen hygiene in their section.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      A commis chef is supervised in their work and reports to a senior chef. In a smaller establishment this may be the Head Chef or Chef Patron or may be a Chef de Partie in a larger organisation using the kitchen hierarchy system.
                    </p>
                  </div>

                  {/* Typical Job Titles */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Typical job titles include:
                    </h4>
                    
                    <div style={{ 
                      padding: '20px', 
                      backgroundColor: '#f8f9fa', 
                      borderRadius: '12px',
                      marginBottom: '20px'
                    }}>
                      <p style={{ color: '#495057', fontSize: '1.1rem', fontWeight: '600', marginBottom: 0 }}>
                        Commis chef
                      </p>
                    </div>

                    <div className="alert" style={{ 
                      backgroundColor: '#fff3cd', 
                      border: '1px solid #ffc107', 
                      borderRadius: '8px', 
                      padding: '20px'
                    }}>
                      <p style={{ color: '#856404', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '10px' }}>
                        If you meet most of these responsibilities as part of your existing role, or if you could be supported to meet these responsibilities during your apprenticeship, you could be suitable for this programme.
                      </p>
                    </div>
                  </div>

                  {/* Role Requirements */}
                  <div className="mb-5">
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px' }}>
                      <li style={{ marginBottom: '12px' }}>Is your role in a kitchen environment?</li>
                      <li style={{ marginBottom: '12px' }}>Required to prepare food from fresh produce using a variety of knives?</li>
                      <li style={{ marginBottom: '12px' }}>Required to set up and close the kitchen when required?</li>
                      <li style={{ marginBottom: '12px' }}>Required to complete relevant kitchen documentation?</li>
                      <li style={{ marginBottom: '12px' }}>Required to maintain food safety and store ingredients in your role?</li>
                      <li style={{ marginBottom: '12px' }}>Required to prepare and cook the following food from scratch - seafood, meat, poultry, vegetables, sauces, soup, bread, pastries, cakes and hot and cold desserts?</li>
                    </ul>
                  </div>

                  {/* The Modules */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      The modules
                    </h4>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px' }}>
                      <li style={{ marginBottom: '10px' }}>Food Safety</li>
                      <li style={{ marginBottom: '10px' }}>Legislation and Health and Safety</li>
                      <li style={{ marginBottom: '10px' }}>Your Team</li>
                      <li style={{ marginBottom: '10px' }}>Kitchen Operations</li>
                      <li style={{ marginBottom: '10px' }}>Cooking Methods</li>
                      <li style={{ marginBottom: '10px' }}>Meat, Poultry, Game and Offal</li>
                      <li style={{ marginBottom: '10px' }}>Nutrition and Healthy Eating</li>
                      <li style={{ marginBottom: '10px' }}>Vegetables</li>
                      <li style={{ marginBottom: '10px' }}>Vegetable Protein, Pasta, Rice and Eggs</li>
                      <li style={{ marginBottom: '10px' }}>Fish and Shellfish</li>
                      <li style={{ marginBottom: '10px' }}>Bread Dough and Pastry</li>
                      <li style={{ marginBottom: '10px' }}>Desserts</li>
                      <li style={{ marginBottom: '10px' }}>Sauces, Stocks and Soups</li>
                      <li style={{ marginBottom: '10px' }}>Communication and Conflict</li>
                      <li>Business Operations</li>
                    </ul>
                  </div>

                  {/* Qualifications */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      Qualifications
                    </h3>

                    {/* English and Maths */}
                    <div className="mb-4">
                      <h4 style={{ color: '#495057', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                        English and Maths
                      </h4>
                      <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                        The completion of English and maths qualifications are optional. The opportunity to complete these is available during the apprenticeship if the apprentice and employer agree.
                      </p>
                    </div>

                    {/* Occupational Level */}
                    <div className="mb-4">
                      <h4 style={{ color: '#495057', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                        Occupational Level:
                      </h4>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '2px solid #7B3F9E'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1.2rem', fontWeight: '600', marginBottom: 0 }}>
                          2
                        </p>
                      </div>
                    </div>

                    {/* Duration */}
                    <div className="mb-4">
                      <h4 style={{ color: '#495057', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                        Duration (months):
                      </h4>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#f8f9fa', 
                        borderRadius: '8px',
                        border: '2px solid #7B3F9E'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1.2rem', fontWeight: '600', marginBottom: 0 }}>
                          12
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Blended Delivery */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px' }}>
                      Blended delivery
                    </h4>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      1:1 facilitated learning sessions with Learning Coach. Face-to-face and remote teaching and self-study.
                    </p>
                  </div>

                  {/* End Point Assessment */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px' }}>
                      End point assessment
                    </h4>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      75-minute multiple choice test, 3-hour Practical Observation with questions, and 60-minute professional discussion.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default CommisChefLevel2;